import React from "react";
import classnames from "classnames";
import cardBack from "./images/cardBack.png";
import "./card.scss";

const Card = ({ onClick, card, index, isInactive, isFlipped, isDisabled }) => {
  const handleClick = () => {
    !isFlipped && !isDisabled && onClick(index);
  };
  //console.log(card);
  return (
    <div
      className={classnames("card", {
        "is-flipped": isFlipped,
        "is-inactive": isInactive,
      })}
      onClick={handleClick}
    >
      <div className="card-face card-font-face">
        <img src={cardBack} alt="cardBack" />
      </div>
      <div className="card-face card-back-face">
        <img src={card.image} alt="hoot" />
      </div>
    </div>
  );
};

export default Card;
